module.exports = "img/ing-agro-2.0ebc50.jpg";